<template>
  <v-navigation-drawer :app="true" :permanent="true" :mini-variant="miniDisplay" :class="currentEnvironmentColor()">
    <template v-slot:prepend>
      <the-sidebar-header @toggle="toggleMiniDisplay" />
    </template>

    <the-sidebar-navigation class="mb-12" />
    <span class="mt-12">
      <h2 class="environment-header" :class="currentTextColor()">
        {{ currentEnvironmentText }}
      </h2>
    </span>

    <template v-slot:append>
      <the-sidebar-footer />
    </template>
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from 'vue';
import TheSidebarHeader from './the-sidebar-header.vue';
import TheSidebarNavigation from './the-sidebar-navigation.vue';
import TheSidebarFooter from './the-sidebar-footer.vue';
import { Environment } from '@/models/environment-enum';
import { environment } from '../../../environment';

export default Vue.extend({
  name: 'TheSidebar',
  components: { TheSidebarHeader, TheSidebarNavigation, TheSidebarFooter },
  data() {
    return {
      miniDisplay: false
    };
  },

  computed: {
    currentEnvironmentText(): string {
      if (environment.TURBINE_ENV == Environment.DEV.toLowerCase()) {
        return Environment.DEV;
      }
      if (environment.TURBINE_ENV == Environment.QA.toLowerCase()) {
        return Environment.QA;
      }
      if (environment.TURBINE_ENV == Environment.UAT1.toLowerCase()) {
        return Environment.UAT1;
      }
      if (environment.TURBINE_ENV == Environment.PREP.toLowerCase()) {
        return Environment.PREP;
      }
      return '';
    }
  },

  methods: {
    toggleMiniDisplay(): void {
      this.miniDisplay = !this.miniDisplay;
    },

    currentEnvironmentColor() {
      if (environment.TURBINE_ENV == Environment.DEV.toLowerCase()) {
        return 'blue-grey darken-1';
      }
      if (environment.TURBINE_ENV == Environment.QA.toLowerCase()) {
        return 'deep-purple lighten-1';
      }
      if (environment.TURBINE_ENV == Environment.UAT1.toLowerCase()) {
        return 'amber lighten-3';
      }
      if (environment.TURBINE_ENV == Environment.PREP.toLowerCase()) {
        return 'red lighten-4';
      }
      return 'white';
    },

    currentTextColor() {
      if (environment.TURBINE_ENV == Environment.DEV.toLowerCase()) {
        return 'blue-grey--text text--lighten-3';
      }
      if (environment.TURBINE_ENV == Environment.QA.toLowerCase()) {
        return 'deep-purple--text text--darken-1';
      }
      if (environment.TURBINE_ENV == Environment.UAT1.toLowerCase()) {
        return 'amber--text text--darken-3';
      }
      if (environment.TURBINE_ENV == Environment.PREP.toLowerCase()) {
        return 'red--text text--lighten-3';
      }
      return 'white';
    }
  }
});
</script>

<style lang="scss" scoped>
.no-focus.v-list-item--link:before {
  background-color: black;
}

.environment-header {
  transform: rotate(-90deg);
}
</style>
